// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {
    /* Store Custom Code - Start */
    1: "0 0 1px 0 rgba(48, 49, 51, 0.05), 0 2px 4px 0 rgba(48, 49, 51, 0.1)",
    2: "0 10px 15px 0 rgba(93, 93, 93, 0.1)",
    3: "0 0 1px 0 rgba(48, 49, 51, 0.05), 0 16px 24px 0 rgba(48, 49, 51, 0.1)",
    /* Store Custom Code - End */
};

export default shadows;
